import comp from "./NoEvidenceView";
export default comp;
